import React from 'react';
import { motion } from 'framer-motion';

interface DashboardPageProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}

const DashboardPage: React.FC<DashboardPageProps> = ({ title, subtitle, children, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className={`p-4 sm:p-6 lg:p-8 w-full container mx-auto max-w-[1600px] ${className}`}
    >
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-white">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
            {subtitle}
          </p>
        )}
      </div>
      
      <div className="w-full">
        {children}
      </div>
    </motion.div>
  );
};

export default DashboardPage; 